import React, { ReactNode } from 'react';

export type ButtonIconPropsType = {
  icon?: ReactNode;
  id?: string;
};

function ButtonIcon({ icon, id }: ButtonIconPropsType) {
  return (
    <span
      className="elmo-btn__icon"
      data-testid={`elmo-btn-icon-${id || 'default'}`}
    >
      {icon}
    </span>
  );
}

export default ButtonIcon;
